export const toastOptions = {
    position: 'top-right' as const,
    style: {
        background: '#ffffff',
        boxShadow: `0px 2px 4px rgba(0,0,0,0.2)`,
        width: 305,
    },
    error: {
        style: {
            color: '#bd0000',
        },
        duration: 5 * 1000,
    },
    loading: {
        style: {
            color: '#499fda',
        },
        duration: 3 * 1000,
    },
    success: {
        style: {
            color: '#5CB46A',
        },
        duration: 3 * 1000,
    }
}